import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { ErgonomicToolsService } from '@/infra/services/ergonomic-tool';

interface GetErgonomicToolsByReportParams {
	organization_id: string;
	company_id: string;
	custom_report_id?: string | null;
	report_ids?: string[];
	start_date?: string;
	end_date?: string;
}

const Service = ErgonomicToolsService.getInstance();

export const useGetErgonomicToolsByReport = (params: GetErgonomicToolsByReportParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_ERGONOMIC_TOOLS_BY_REPORT, params],
		queryFn: () => Service.findAllByReport(params),
		enabled: !!params.organization_id && !!params.company_id
	});
};
